import React, { useState, useEffect, FC } from 'react';
import './preview-table-row.scss';
import { Checkbox } from 'primereact/checkbox';
import { Chip } from 'primereact/chip';
import { typeIdToLabel } from '../other-table-row/other-table-row';

export interface PreviewTableRowProps {
    object: any;
    headers: any[];
    checked: boolean;
    setChecked: (checked: boolean, id: string) => void;
}

const PreviewTableRow:FC<PreviewTableRowProps> = (props) => {
    const [stock, setStock] = useState(props);
    //dispatch update here
    const handleUpdateStock = (propertyName, value) => {
        setStock({...stock, [propertyName]: value});
    }
    return (
        <div className="preview-table-row" key={props.object.id}>
            <Checkbox onChange={e => props.setChecked(e.checked, props.object.id)} checked={props.checked}></Checkbox>
            {props.headers.map((header, index) => {
                if(header.field === 'type'){    
                    return <Chip label={typeIdToLabel[props.object.type]} className={typeIdToLabel[props.object.type]} />
                }
                else{
                    return <div key={`${props.object.id}-${header.field}`} className={`preview-table-row__label ${header.style}`}>{props.object[header.field]}</div>
                }
            })}
        </div>
    );
}
         
export default PreviewTableRow;